import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";

export enum EventType {
  purchase = "PURCHASE",
  ADD_CART = "ADD_CART",
  checkout = "START_CHECKOUT",
  VIEW_CONTENT = "VIEW_CONTENT",
  view_item_list = "LIST_VIEW",
  ADD_BILLING = "ADD_BILLING",

  //new events for GA and GTM
  view_cart = "view_cart",
  remove_from_cart = "remove_from_cart",
  add_shipping_info = "add_shipping_info",
  userLogin = "userLogin",
  search_event = "search_event",
  maillist_conversion = "maillist_conversion",
}
export enum Tracker {
  FBP = "Facebook-Pixel",
  SCP = "Snapchat-Pixel",
  GTAG = "Google-Tag",
  GA = "Google-Analytics",
  TIK = "Tiktok-pixel",
}

export type GtagActionField = {
  currency?: string;
  value?: number;
  discount?: number;
  coupon?: string;
  shipping?: number;
  transaction_id?: string;
  tax?: number;
  item_list_id?: string;
  item_list_name?: string;
  shipping_tier?: string;
  payment_type?: string;
  // Invoice details for purchase events
  invoice_id?: string | number;
  invoice_number?: string;
  invoice_date?: string;
  invoice_time?: string;
  event_name?: string;
  city_name?: string;
};

export type SnapchatActionField = {
  transaction_id?: string;
  currency: string;
  price: number;
  discount?: number;
  item_ids: string[];
  number_items: number;
  user_email?: string;
  user_hashed_email?: string;
  user_phone_number?: string;
  user_hashed_phone_number?: string;
  firstname?: string;
  lastname?: string;
};
export type FacebookActionField = {
  currency: string;
  value: number;
  discount?: number;
  content_ids: string[];
  content_type?: string;

  email?: string;
  email_hash?: string;
  phone?: string;
  phone_hash?: string;
  external_id?: string;
  client_ip_address?: string;
  client_user_agent?: string;
  fbc?: string; // Facebook click ID
  fbp?: string; // Facebook browser ID

  // Invoice details for purchase events
  invoice_id?: string;
  invoice_number?: string;
  invoice_date?: string;
  invoice_time?: string;
  // eventID?: string;
};
export type TiktokActionField = {
  currency: string;
  value: number;
  content_ids: string[];
  content_type?: string;
};

export type EventItem = {
  parent: { name: string; sku: string };
  type: ProductPreviewTypes;
  inner_id: number;
  name: string;
  discount: number;
  id?: number;
  price: number;
  quantity: number;
  attrs_values?: {
    id?: number;
    name: string;
    type?: string;
    key?: string;
  }[];
  categories_names?: string[];
};

export interface IGTagUserData {
  name?: string;
  email?: string;
  email_hash?: string;
  phone?: string;
  phone_hash?: string;
  user_id?: string | number;
}
